import Picker, { PickerValue } from 'react-mobile-picker'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import React, { useState } from 'react'
import Popup from './Popup'

interface TimePickerProps {
  time?: string
  minTime?: string
  maxTime?: string
  defaultTime?: string
  /** tylko te godziny ("GG:MM") są do wyboru; zastępuje minTime/maxTime */
  allowedTimes?: string[]
  onChange: (time: string) => void
  close?: basic.BasicFunc
}

const TimePickerPopup: React.FC<TimePickerProps> = ({ time, minTime, maxTime, defaultTime = '12:00', allowedTimes, onChange, close: _close }) => {
  const [timeValue, setTimeValue] = useState<PickerValue>(() => {
    const initial = allowedTimes && allowedTimes.length > 0 && !(time && allowedTimes.includes(time))
      ? allowedTimes[0]
      : time || defaultTime
    const [hour, minute] = initial.split(':')
    return { hour, minute }
  })

  const min = getTimeNumber(minTime)
  const max = getTimeNumber(maxTime)

  const allowed = allowedTimes && allowedTimes.length > 0 ? allowedTimes : undefined
  const hours = allowed
    ? Array.from(new Set(allowed.map(t => t.slice(0, 2))))
    : Array.from(Array((max?.hour || 24) - (min?.hour || 0))).map((_, i) => String(i + (min?.hour || 0)).padStart(2, '0'))
  const minutes = allowed
    ? allowed.filter(t => t.slice(0, 2) === timeValue.hour).map(t => t.slice(3, 5))
    // eslint-disable-next-line eqeqeq
    : Array.from(Array((timeValue?.hour == max?.hour ? max?.minute : 60) - (timeValue?.hour == min?.hour ? min?.minute : 0))).map((_, i) => String(i + (timeValue?.hour == min?.hour ? min?.minute : 0)).padStart(2, '0'))

  const { goBack } = useHistory()
  const { t } = useTranslation('form')
  const close = _close || goBack

  return (
    <Popup
      save={() => {
        onChange(`${timeValue.hour}:${timeValue.minute}`)
        close()
      }}
      close={_close}>
      <div className='popup__main__time'>
        <div className='popup__main__time__header'>
          <span>{t('hour')}</span>
          <span>{t('minute')}</span>
        </div>

        <Picker
          value={timeValue}
          wheelMode='natural'
          className='timePicker'
          onChange={(newValue) => {
            // przy liście dozwolonych godzin minuta musi istnieć dla wybranej godziny
            if (allowed && !allowed.includes(`${newValue.hour}:${newValue.minute}`)) {
              const first = allowed.find(t => t.slice(0, 2) === newValue.hour)
              if (first) newValue = { ...newValue, minute: first.slice(3, 5) }
            }
            setTimeValue(newValue)
          }}>

          <Picker.Column name='hour'>
            {hours.map((hour) => (
              <Picker.Item
                key={hour}
                value={hour}>
                {({ selected }) => <div className={`timePicker__option --secFont ${selected ? ' --selected' : ''}`}>{hour}</div>}
              </Picker.Item>))}
          </Picker.Column>

          <Picker.Column name='minute'>
            {minutes.map((minute) => (
              <Picker.Item
                key={minute}
                value={minute}>
                {({ selected }) => <div className={`timePicker__option --secFont ${selected ? ' --selected' : ''}`}>{minute}</div>}
              </Picker.Item>))}
          </Picker.Column>
        </Picker>
      </div>
    </Popup>
  )
}

const getTimeNumber = (time?: string) => {
  if (!time || !time.includes(':')) return
  const [hour, minute] = time.split(':')
  if (hour && minute) {
    return {
      hour: Number(hour),
      minute: Number(minute)
    }
  }
}

export default TimePickerPopup